import styles from './Spinner.module.css';

export type SpinnerProps = {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  inline?: boolean;
  fullViewport?: boolean;
};

export function Spinner({
  message,
  size = 'md',
  inline = false,
  fullViewport = false,
}: SpinnerProps) {
  const ring = (
    <span
      className={`${styles.ring} ${styles[size]} ${inline ? styles.inline : ''}`}
      role="status"
      aria-label={message ?? 'Carregando'}
    />
  );

  if (fullViewport) {
    return (
      <div className={styles.viewport}>
        {ring}
        {message ? <p className={styles.message}>{message}</p> : null}
      </div>
    );
  }

  if (message) {
    return (
      <div className={styles.withMessage}>
        {ring}
        <span className={styles.message}>{message}</span>
      </div>
    );
  }

  return ring;
}
